import React from 'react';
import { UserIcon, UsersIcon } from '@heroicons/react/24/outline';

const AccountTypeStep = ({ formData, handleInputChange, nextStep, prevStep, errors }) => {
  const handleTypeSelect = (type) => {
    handleInputChange({ target: { name: 'accountType', value: type } });
    // Initialize profile or children array based on account type
    if (type === 'self') {
      handleInputChange({
        target: {
          name: 'profile',
          value: {
            dateOfBirth: '',
            gender: '',
            genderOther: '',
            ethnicity: '',
            ethnicityOther: '',
            disability: '',
            disabilityOther: '',
            interests: [],
            educationStatus: '',
            ehcp: false,
            dla: false,
            pip: false
          }
        }
      });
    } else if (type === 'children') {
      handleInputChange({
        target: {
          name: 'children',
          value: []
        }
      });
    }
    nextStep();
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900 text-center">Who are you creating this account for?</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Self Account Option */}
        <button
          type="button"
          onClick={() => handleTypeSelect('self')}
          className="p-4 border border-gray-200 rounded-lg text-left transition-all hover:border-blue-500 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <div className="flex flex-col items-center text-center space-y-3">
            <div className="p-2 bg-blue-100 rounded-full">
              <UserIcon className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-900">For Myself</h4>
              <p className="mt-1 text-xs text-gray-500">
                Create an account to access services and support for yourself
              </p>
            </div>
          </div>
        </button>

        {/* Children Account Option */}
        <button
          type="button"
          onClick={() => handleTypeSelect('children')}
          className="p-4 border border-gray-200 rounded-lg text-left transition-all hover:border-blue-500 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <div className="flex flex-col items-center text-center space-y-3">
            <div className="p-2 bg-blue-100 rounded-full">
              <UsersIcon className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-900">For My Children</h4>
              <p className="mt-1 text-xs text-gray-500">
                Create profiles and manage services for your children
              </p>
            </div>
          </div>
        </button>
      </div>

      {errors.accountType && (
        <p className="text-xs text-red-600 text-center">{errors.accountType}</p>
      )}

      <div className="flex justify-between mt-6">
        <button
          type="button"
          onClick={prevStep}
          className="py-1.5 px-3 border border-gray-300 rounded-md shadow-sm text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default AccountTypeStep; 